import { useEffect, useState, useContext } from 'react';
import { GlobalState } from "./../../../context/globalState";
import { Row, Col, Form, Input, Checkbox, Radio, Button, message } from "antd";
import ButtonComponent from "./../../../components/button/index";
import MDDone from "./../components/modal/mdDone";
import MDWarningCreate from "./../components/modal/mdWarningCreate";
import dayjs from "dayjs";
import Server from "./../../../lib/getAPI";
import Images from "./../../../asset/exportImages";
import Signature from "./../../../components/signature/index";
import IconArrowUp from "./../../../asset/icons/arrow-up-sm.svg";
import { trackProductEvent } from '../../../lib/trackingService';


const PaymentInfomation = () => {
  const { isMobile, listOfInsuredPeople, Helper, setStep, buyerInfo, dataOrder, setDataOrder, OpenLink, setLoading, dataFees, setDataFees, messageErr, scrollIntoViewID, openNotification } = useContext(GlobalState);
  const [selectedIds, setSelectedIds] = useState([...Array(listOfInsuredPeople.length).keys()]);
  const [dataPayment, setDataPayment] = useState({});
  const [collaboratorInfo, setCollaboratorInfo] = useState(null);
  const showReward = Helper.getParamUrlByKey("reward") === "true" ? true : false;
  const [openMD, setOpenMD] = useState(false);
  const [openWarning, setOpenWarning] = useState(false);
  const [viewListOfInsuredPeople, setViewListOfInsuredPeople] = useState((isMobile && listOfInsuredPeople.length > 2) ? false : true);
  const [subsidy, setSubsidy] = useState(0);
  const [isMaxSubsidy, setIsMaxSubsidy] = useState(false);
  const [form] = Form.useForm();

  const toggleSelection = (id) => {
    setSelectedIds((prevSelectedIds) =>
      prevSelectedIds.includes(id)
        ? prevSelectedIds.filter((itemId) => itemId !== id)
        : [...prevSelectedIds, id]
    );
  };

  const getInfoCollaborate = async () => {
    try {
      const res = await Server.apiCallOpenVerify("GET", "/v1/products/collaborator-detail");
      console.log(">>>", res);

      if (res?.data?.success) {
        setCollaboratorInfo(res.data.data);
        try {
          localStorage.setItem("collaboratorInfo", JSON.stringify(res.data.data));
        } catch (e) {}
      }
    } catch (err) {
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    trackProductEvent("product_review_viewed", {
      order_id: null,
    });
    getInfoCollaborate()
    if (Helper.getParamUrlByKey('platform') === 'app' && !showReward) {
      Commission();
    }
    if (showReward) {
      getBalance();
    }
  }, []);

  const handelCanCel = () => {
    setOpenWarning(false);
  }

  const infoBuyer = [
    { title: 'Họ và tên', value: buyerInfo?.buyerName },
    // { title: 'Giới tính', value: buyerInfo?.buyerGender === 'MALE' ? 'Nam' : 'Nữ' },
    { title: 'Ngày sinh', value: Helper._formatDayNoHour(buyerInfo?.buyerDob) },
    { title: 'CCCD/ Số định danh', value: buyerInfo?.buyerPrivateId },
    { title: 'Số điện thoại', value: buyerInfo?.buyerPhone },
    { title: 'Email', value: buyerInfo?.buyerEmail },
    { title: 'Địa chỉ', value: buyerInfo?.buyerAddress }
  ]

  const getListIsured = () => {
    let arrInsu = [];
    listOfInsuredPeople.map(
      (value) => {
        arrInsu = [
          ...arrInsu,
          {
            insuredName: value?.insuredName,
            insuredDob: dayjs(value?.insuredDob).format("DD/MM/YYYY"),
            // insuredGender: value?.insuredGender === 'MALE' ? 1 : 2,
            insuredPrivateId: value?.insuredPrivateId,
            ...((value?.self) ? { buyYourSelf: true } : {}),
            ...((value?.privateIdUrl) ? { imgPrivatedId: value.privateIdUrl } : {})
          },
        ]
      }
    );
    return arrInsu;
  };

  // Lấy tiền thưởng trên Gsale
  const getBalance = async () => {
    setLoading(true);
    await Server.apicall("GET", `/api/v1/wallet/reward/balance`)
      .then((res) => {
        setLoading(false);
        if (res?.data?.statusCode === 200) {
          let balance = +res?.data?.result?.wallet?.balance;
          let feesBalance = (balance >= dataFees.totalInsured) ? dataFees.totalInsured : balance
          setDataFees({
            ...dataFees,
            reward: feesBalance,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          messageErr(err.response.data.statusCode, err.response.data.message);
        }
      });
  };

  // Kiểm tra mã ưu đãi
  const RedeemVerify = (value) => {
    if (!dataOrder?.redeemCode) {
      message.error('Vui lòng nhập mã ưu đãi!');
      return;
    }
    setLoading(true);
    let data = {
      "productId": 93,
      "amount": +dataOrder?.fees, // phí bảo hiểm 1 người
      insuredInfo: {
        yearsOfInsuredPeople: +dataOrder?.yearsOfInsurance,
        packageCode: dataOrder?.packageCode,
        beginDate: dayjs(buyerInfo?.beginDate).format("DD/MM/YYYY"),
        numberOfPeopleInFamily: listOfInsuredPeople.length,
      },
      listOfInsuredPeople: getListIsured(),
    }
    Server.apicall("POST", `/api/v1/redeem-code/${dataOrder?.redeemCode}/verify`, data)
      .then((res) => {
        setLoading(false);
        let data = res?.data;
        if (data?.statusCode === 200) {
          message.success('Áp dụng mã giảm giá thành công!');
          trackProductEvent("discount_applied", {
            discount_code: data?.result?.code || dataOrder?.redeemCode,
            discount_amount: data?.result?.discountAmount || 0,
            discount_pct: data?.result?.discountPct || 0,
          });
          setDataFees({
            ...dataFees,
            discountAmount: data?.result?.discountAmount,
            redeemCode: data?.result?.code,
            nonCommission: data?.result?.nonCommission || false
          })
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          openNotification(err.response.data.message, err.response.data.statusCode);
          form.setFieldsValue({ redeemCode: undefined });
          setDataFees({
            ...dataFees,
            discountAmount: 0,
            redeemCode: '',
            nonCommission: false
          })
          setDataOrder({ ...dataOrder, redeemCode: undefined });
        }
      });
  };

  // Lấy hoa hồng của sản phẩm
  const Commission = () => {
    setLoading(true);
    let data = {
      reward: showReward ? 1 : undefined,
      insuredInfo: {
        yearsOfInsuredPeople: +dataOrder?.yearsOfInsurance,
        packageCode: dataOrder?.packageCode,
        beginDate: dayjs(buyerInfo?.beginDate).format("DD/MM/YYYY"),
        numberOfPeopleInFamily: listOfInsuredPeople.length,
      },
      listOfInsuredPeople: getListIsured(),
    }
    Server.apicall("POST", `/api/v1/product/family-accident/commission`, data)
      .then((res) => {
        setLoading(false);
        let data = res?.data;
        if (data?.statusCode === 200) {
          setDataFees({
            ...dataFees, commision: data.result.commission, subsidyAmount: data?.result?.subsidyAmount || 0
          })
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          // messageErr(err.response.data.statusCode, err.response.data.message);
          openNotification(err.response.data.message, err.response.data.statusCode);
        }
      });
  };

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        if (!values.signature) {
          message.error('Vui lòng ký tên để tiếp tục!');
          return;
        }
        setOpenWarning(true);
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  const create = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        handleImportFile(values);
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  const handleImportFile = async (values) => {
    if (!values.signature) {
      message.error('Vui lòng ký tên!')
      return
    };
    setLoading(true);

    try {
      // 1) Upload chữ ký
      const uploadForm = new FormData();
      const timestamp = Date.now();
      uploadForm.append("storage", "s3");
      uploadForm.append("file", values.signature);
      uploadForm.append("path", `/user/signature/${timestamp}-signature`);
      const uploadRes = await Server.apicall_upload_G2("POST", "/upload", uploadForm);
      const uploadData = uploadRes?.data;
      if (!uploadData?.complete) throw new Error("Upload chữ ký thất bại");

      const linkSignature = uploadData.link;
      createOrder(values, linkSignature);

    } catch (err) {
      if (err.response) {
        // messageErr(err.response.data.statusCode, err.response.data.message);
        openNotification(err.response.data.message, err.response.data.statusCode);
      }
    } finally {
      setLoading(false);
    }
  };

  const createOrder = (values, linkSignature) => {
    setLoading(true);
    const platform = Helper.getParamUrlByKey("platform");
    const partnerStaffId = Helper.getParamUrlByKey("staff_id");
    const optionalPartner = Helper.getParamUrlByKey("optional_partner");
    const data = {
      "productCode": "tnhgd",
      "providerId": 15,
      "redeemCode": dataFees?.redeemCode || undefined, // Optional
      "appliedCommissionAmount": subsidy || 0, // Optional
      "reward": showReward ? 1 : undefined,
      "insuredInfo": {
        "buyerName": buyerInfo?.buyerName,
        "buyerPrivateId": buyerInfo?.buyerPrivateId,
        "buyerPhone": buyerInfo?.buyerPhone,
        "buyerEmail": buyerInfo?.buyerEmail,
        "buyerGender": buyerInfo?.buyerGender === "MALE" ? 1 : 2,
        "buyerAddress": buyerInfo?.buyerAddress,
        "buyerDob": dayjs(buyerInfo?.buyerDob).format("DD/MM/YYYY"),
        "beginDate": dayjs(buyerInfo?.beginDate).format("DD/MM/YYYY"),
        "packageCode": dataOrder?.packageCode,
        "signature": linkSignature,
        "buyerImgPrivatedId": buyerInfo?.privateIdUrl || undefined,
        "numberOfPeopleInFamily": listOfInsuredPeople?.length,
        "affArticleUid": Helper.getParamUrlByKey('aff_article_uid') || undefined, // optional
        "partnerStaffId": partnerStaffId || undefined,
        "optionalPartner": optionalPartner || undefined
      },
      "listOfInsuredPeople": getListIsured(),
    }
    data.insuredInfo.vatInfo = dataOrder?.buyVAT === 'YES' ? // optional
      {
        "typeId": dataOrder?.typeVAT === 'PERSONAL' ? 1 : 2, // 'PERSONAL' | 'BUSINESS';
        "typeName": dataOrder?.typeVAT === 'PERSONAL' ? 'Cá nhân' : 'Doanh Nghiệp',
        "name": values?.name,
        "taxCode": values?.taxCode,
        "address": values?.address,
      }
      : undefined
    // console.log('data tao don', data);
    // return
    Server.apicall(
      "POST", `/api/v1/product/family-accident/${platform === 'app' ? 'add-to-cart' : 'create'}?callback=${platform === 'app' ? '' : encodeURIComponent(
        window.location.href
      )}`,
      data
    )
      .then((res) => {
        setLoading(false);
        let data = res?.data;
        if (data?.statusCode === 200) {
          const resData = data?.data || {};
          const totalFee = Math.max(0, (dataFees?.totalInsured || 0) - (dataFees?.reward || 0) - (dataFees?.discountAmount || 0) - (subsidy || 0)) || dataFees?.totalInsured || dataOrder?.fees || 0;
          const premiumFee = Number(dataFees?.totalInsured || dataOrder?.fees || totalFee);

          setDataPayment({
            ...resData,
            amount: Number(resData?.amount || resData?.totalAmount || totalFee),
            totalAmount: Number(resData?.totalAmount || resData?.amount || totalFee),
            fees: Number(resData?.fees || premiumFee),
          });
          NextPayment();
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          // messageErr(err.response.data.statusCode, err.response.data.message);
          openNotification(err.response.data.message, err.response.data.statusCode);
        }
      });
  };

  const NextPayment = () => {
    // Helper.clearLocal();
    setOpenMD(true);
  }

  const openQuytac = () => {
    OpenLink('https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/quy-tac-bh-tai-con-nguoi.pdf');
  }

  function _formatMoney(str) {
    if (str) {
      return str
        .toString()
        .replace(/\./, ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
    return 0;
  }

  return (
    <>
      {
        openMD &&
        <MDDone dataPayment={dataPayment} />
      }
      {
        openWarning &&
        <MDWarningCreate handelCanCel={handelCanCel} create={() => create()} />
      }
      <Form
        layout={"vertical"}
        form={form}
        onFinish={onFinish}
        onFinishFailed={(e) => {
          scrollIntoViewID(e?.errorFields?.[0]?.name?.[0]);
          if (e?.errorFields?.[0]?.name?.[0] === 'signature') {
            message.error('Vui lòng ký tên để tiếp tục!');
          }
        }}
        onFocus={(e) => {
          scrollIntoViewID(e.target.id);
        }}
        requiredMark={(label, { required }) => (
          <>
            {label}
            {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
          </>
        )}
        onValuesChange={(changedValues, allValues) => {
          if (window.__debounceTimer) clearTimeout(window.__debounceTimer);
          window.__debounceTimer = setTimeout(() => {
            setDataOrder({ ...dataOrder, ...allValues });
          }, 500);
        }}
        initialValues={{
          buyVAT: undefined,
          name: Helper.capitalize(dataOrder?.name) || Helper.capitalize(buyerInfo?.buyerName),
          taxCode: dataOrder?.taxCode,
          address: dataOrder?.address || buyerInfo?.buyerAddress,
        }}
      >
        <Row gutter={isMobile ? [0, 15] : [15, 15]} style={{ maxWidth: 900, margin: '0px auto' }}>
          <Col xs={24} >
            <div className="card-info">
              <div className="card" style={{ background: '#fff', padding: 0 }}>
                {
                  isMobile ?
                    <div className="card-header" style={{ background: '#F0F2F5', borderRadius: 12, padding: 10, display: 'grid', gap: 10 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                          <img style={{ width: 32, objectFit: 'cover' }} src={dataOrder.urlIcon} alt="logo" />
                          <b className="title" style={{ color: '#343A40' }}>{dataOrder?.title}</b>
                        </div>
                        <div>
                          <img
                            onClick={() => {
                              trackProductEvent("product_review_edited", {
                                field_name: "package_info",
                              });
                              setStep(2);
                            }}
                            src={Images.ICChinhSua}
                            width={isMobile ? 12 : 18}
                            height={isMobile ? 12 : 18}
                            style={{ marginBottom: -3, marginRight: 4, cursor: 'pointer' }}
                          />
                        </div>
                      </div>
                      <div style={{ width: '100%', height: '0.5px', background: '#d2d2d2' }}></div>
                      <div className="info-row">
                        <div style={{ color: '#646D69' }}>Thời hạn bảo hiểm:</div>
                        <div style={{ color: '#343A40' }} className="highlight">{dataOrder?.yearsOfInsurance} năm</div>
                      </div>
                      <div style={{ background: '#fff', padding: '5px 9px', borderRadius: 200, textAlign: 'center', fontSize: 14 }}>
                        <span style={{ color: '#646D69' }}>Từ: </span>
                        <span style={{ color: '#FB7800' }}><b>{dayjs(buyerInfo.beginDate).format("DD/MM/YYYY")}</b> </span>
                        <span style={{ color: '#646D69' }}>Đến: </span>
                        <span style={{ color: '#FB7800' }}><b>{dayjs(buyerInfo.endDate).format("DD/MM/YYYY")}</b> </span>
                      </div>
                    </div> :

                    <div className="card-header" style={{ background: '#F0F2F5', borderRadius: 12, padding: 10, display: 'flex', gap: 10 }}>
                      <img style={{ width: 80, objectFit: 'cover' }} src={dataOrder.urlIcon} alt="logo" />
                      <div style={{ display: 'grid', gap: 10, width: '100%' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                            <b className="title" style={{ color: '#343A40', fontSize: 18 }}>{dataOrder?.title}</b>
                          </div>
                          <div>
                            <img
                              onClick={() => {
                                trackProductEvent("product_review_edited", {
                                  field_name: "package_info",
                                });
                                setStep(2);
                              }}
                              src={Images.ICChinhSua}
                              width={isMobile ? 12 : 18}
                              height={isMobile ? 12 : 18}
                              style={{ marginBottom: -3, marginRight: 4, cursor: 'pointer' }}
                            />
                          </div>
                        </div>
                        <div style={{ width: '100%', height: '0.5px', background: '#d2d2d2' }}></div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div className="info-row">
                            <div style={{ color: '#646D69' }}>Thời hạn bảo hiểm:</div>
                            <div style={{ color: '#343A40' }} className="highlight">{dataOrder?.yearsOfInsurance} năm</div>
                          </div>
                          <div style={{ background: '#fff', padding: '5px 9px', borderRadius: 200, textAlign: 'center', fontSize: 16 }}>
                            <span style={{ color: '#646D69' }}>Từ: </span>
                            <span style={{ color: '#FB7800' }}><b>{dayjs(buyerInfo.beginDate).format("DD/MM/YYYY")}</b> </span>
                            <span style={{ color: '#646D69' }}>Đến: </span>
                            <span style={{ color: '#FB7800' }}><b>{dayjs(buyerInfo.endDate).format("DD/MM/YYYY")}</b> </span>
                          </div>
                        </div>
                      </div>
                    </div>
                }

                <div className='gray' style={{ display: 'grid', gap: 10 }}>
                  <>
                    <div className="info-row">
                      <div style={{ color: '#646D69' }}>Tổng quyền lợi bảo hiểm/{isMobile ? <br /> : ''}người/thời hạn bảo hiểm:</div>
                      <div style={{ color: '#009B4B', minWidth: 120 }} className="highlight">
                        {Helper.formatMoney(dataOrder?.benefits?.totalFees)} VNĐ
                      </div>
                    </div>
                    <div className="info-row">
                      <div style={{ color: '#646D69' }}>1. Tử vong hoặc mất tích:</div>
                      <div style={{ color: '#343A40', minWidth: 120 }} className="highlight">
                        {Helper.formatMoney(dataOrder?.benefits?.deathOrDisappearanceFees)} VNĐ
                      </div>
                    </div>
                    <div className="info-row">
                      <div style={{ color: '#646D69' }}>2. Thương tật toàn bộ vĩnh viễn:</div>
                      <div style={{ color: '#343A40', minWidth: 120 }} className="highlight">
                        {Helper.formatMoney(dataOrder?.benefits?.permanentDisabilityFees)} VNĐ
                      </div>
                    </div>
                    <div className="info-row">
                      <div style={{ color: '#646D69' }}>3. Thương tật bộ phận vĩnh viễn:</div>
                      <div onClick={() => OpenLink('https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/bang-ty-le-tra-tien-thuong-tat.pdf')} style={{ color: '#0044CC', textDecoration: 'underline', cursor: 'pointer', minWidth: 190, textAlign: 'right' }}>
                        Bảng tỷ lệ trả tiền thương tật
                      </div>
                    </div>
                    <div className="info-row">
                      <div style={{ color: '#646D69' }}>4. Thương tật tạm thời:</div>
                      <div onClick={() => OpenLink('https://cdn.globalcare.vn/private/pdf/tai-nan-ho-gia-dinh/bang-ty-le-tra-tien-thuong-tat.pdf')} style={{ color: '#0044CC', textDecoration: 'underline', cursor: 'pointer', minWidth: 190, textAlign: 'right' }}>
                        Bảng tỷ lệ trả tiền thương tật
                      </div>
                    </div>
                    <div style={{ background: '#FFF6EE', padding: 5, borderRadius: 8, fontSize: 12, color: '#FB7800' }}>
                      <i>*Ghi chú: Tổng số tiền bảo hiểm chi trả cho các mục từ 1-4: không vượt quá tổng quyền lợi bảo hiểm/người</i>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </Col>

          <Col xs={24} >
            <div className="card-info">
              <div className="info-row" style={{ borderBottom: '0.5px solid #D2D2D2', paddingBottom: 10 }}>
                <div style={{ fontSize: isMobile ? 16 : 18, fontWeight: 500, color: '#343A40' }}><b>Thông tin người mua bảo hiểm</b></div>
                <div>
                  <img
                    onClick={() => {
                      trackProductEvent("product_review_edited", {
                        field_name: "buyer_info",
                      });
                      setStep(3);
                    }}
                    src={Images.ICChinhSua}
                    width={isMobile ? 12 : 18}
                    height={isMobile ? 12 : 18}
                    style={{ marginBottom: -3, marginRight: 4, cursor: 'pointer' }}
                  />
                </div>
              </div>
              {/* <div style={{ height: 1, width: '100%', background: '#D2D2D2' }}></div> */}
              <Row gutter={isMobile ? [15, 15] : [30, 30]}>
                {
                  infoBuyer.map((info, idx) => (
                    <Col key={idx} xs={12} xl={8}>
                      <div className="info-gird  gray">
                        <div style={{ fontSize: isMobile ? 12 : 14 }}>{info.title}</div>
                        <div style={{ wordBreak: 'break-word', color: '#343A40', fontWeight: 500, textTransform: idx === 0 ? 'capitalize' : '', fontSize: isMobile ? 14 : 16 }}><b>{info.value}</b></div>
                      </div>
                    </Col>
                  ))
                }
              </Row>
            </div>
          </Col>
          <Col xs={24}>
            <div className="card-info">
              <div className="info-row" style={{ borderBottom: '0.5px solid #D2D2D2', paddingBottom: 10, marginBottom: 5 }}>
                <div style={{ fontSize: isMobile ? 16 : 18, fontWeight: 500, color: '#343A40' }}><b>Thông tin người được bảo hiểm</b></div>
                <div>
                  <img
                    onClick={() => {
                      trackProductEvent("product_review_edited", {
                        field_name: "insured_info",
                      });
                      setStep(3);
                    }}
                    src={Images.ICChinhSua}
                    width={isMobile ? 12 : 18}
                    height={isMobile ? 12 : 18}
                    style={{ marginBottom: -3, marginRight: 4, cursor: 'pointer' }}
                  />
                </div>
              </div>
              <Row gutter={isMobile ? [10, 10] : [15, 15]}>
                <Col onClick={() => setViewListOfInsuredPeople(!viewListOfInsuredPeople)} xs={24}>
                  <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-start', alignItems: 'center' }}>
                    {
                      !viewListOfInsuredPeople &&
                      <div style={{ borderRadius: '50%', background: '#FB7800', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18 }}>
                        <span>{listOfInsuredPeople.length}</span>
                      </div>
                    }
                    <div style={{ fontSize: isMobile ? 12 : 15, fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: isMobile ? 'flex-end' : '', gap: 8, cursor: 'pointer' }}>
                      {viewListOfInsuredPeople ? 'Thu gọn' : 'Xem chi tiết'}
                      <img src={Images.ICChevronDouble} width={16} style={{ cursor: 'pointer', rotate: viewListOfInsuredPeople ? '180deg' : '' }} />
                    </div>
                  </div>
                </Col>
                {
                  viewListOfInsuredPeople &&
                  listOfInsuredPeople.map((data, index) => (
                    <Col key={index} xs={24} md={12} xl={12} >
                      <div className="card">
                        <div onClick={() => toggleSelection(index)} style={{ cursor: 'pointer' }} className="info-row success">
                          <div style={{ textTransform: 'capitalize' }}>{data?.insuredName}</div>
                          <div style={{ color: '#343A40' }}>
                            <img src={Images.ICDropdow} width={20} style={{ marginBottom: -5, rotate: selectedIds.includes(index) ? '180deg' : '' }} />
                          </div>
                        </div>
                        {
                          selectedIds.includes(index) &&
                          <>
                            {/* <div className="info-row gray">
                              <div>Giới tính:</div>
                              <div style={{ color: '#343A40' }}><b>{data?.insuredGender === 'MALE' ? 'Nam' : 'Nữ'}</b></div>
                            </div> */}
                            <div className="info-row gray">
                              <div>Ngày sinh:</div>
                              <div style={{ color: '#343A40' }}><b>{Helper._formatDayNoHour(data?.insuredDob)}</b></div>
                            </div>
                            <div className="info-row gray">
                              <div>CCCD/Số định danh:</div>
                              <div style={{ color: '#343A40' }}><b>{data?.insuredPrivateId}</b></div>
                            </div>
                          </>
                        }
                      </div>
                    </Col>
                  ))
                }
              </Row>
            </div>
          </Col>

            <Col xs={24}>
              <div className="card-info">
                <div className="info-row" style={{ borderBottom: '0.5px solid #D2D2D2', paddingBottom: 10 }}>
                  <div style={{ fontSize: isMobile ? 16 : 18, fontWeight: 500, color: '#343A40' }}>
                    <b>Thông tin cộng tác viên</b>
                  </div>
                </div>
                <Row gutter={isMobile ? [15, 15] : [30, 30]}>
                  <Col xs={12} xl={8}>
                    <div className="info-gird gray">
                      <div style={{ fontSize: isMobile ? 12 : 14 }}>Họ và tên</div>
                      <div style={{ wordBreak: 'break-word', color: '#343A40', fontWeight: 500, fontSize: isMobile ? 14 : 16 }}>
                        <b>{collaboratorInfo?.fullname || "-"}</b>
                      </div>
                    </div>
                  </Col>
                  <Col xs={12} xl={8}>
                    <div className="info-gird gray">
                      <div style={{ fontSize: isMobile ? 12 : 14 }}>Mã số thuế</div>
                      <div style={{ wordBreak: 'break-word', color: '#343A40', fontWeight: 500, fontSize: isMobile ? 14 : 16 }}>
                        <b>{collaboratorInfo?.taxCode || "-"}</b>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>

          <Col xs={24} >
            <div className="card-info" style={isMobile ? {} : { padding: 0, background: '#fff0' }}>
              <div className="info-row" style={isMobile ? { borderBottom: '0.5px solid #D2D2D2', paddingBottom: 10 } : {}}>
                <div style={{ fontSize: isMobile ? 16 : 18, fontWeight: 500, color: '#343A40' }}><b>Thông tin xuất hoá đơn</b></div>
              </div>
              <Row gutter={[15, 15]}>
                <Col xs={24} xl={24}>
                  <div style={{ display: isMobile ? 'grid' : 'flex', alignItems: 'center', gap: isMobile ? 0 : 30 }}>
                    <div style={{ fontSize: isMobile ? 14 : 16 }}>Lựa chọn xuất hóa đơn VAT?</div>
                    <Form.Item name="buyVAT" label="" rules={[{ required: true, message: 'Vui lòng chọn thông tin xuất hoá đơn!' }]}>
                      <Radio.Group>
                        <Radio value={'NO'} style={{ marginRight: 30 }}>Không</Radio>
                        <Radio value={'YES'}>Có</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </div>
                </Col>
                {
                  dataOrder?.buyVAT === 'YES' &&
                  <>
                    <Col xl={0} xs={24}><div style={{ height: 1, width: '100%', background: '#D2D2D2', marginTop: -5, paddingBottom: 0 }}></div></Col>
                    <Col xs={24}>
                      <div style={{ display: 'flex', gap: 15 }}>
                        <Button onClick={() => {
                          setDataOrder({ ...dataOrder, typeVAT: 'BUSINESS' });
                        }} className={dataOrder?.typeVAT === 'BUSINESS' ? 'btnActiveVAT' : 'btnVAT'}>
                          Doanh nghiệp
                        </Button>
                        <Button onClick={() => setDataOrder({ ...dataOrder, typeVAT: 'PERSONAL' })} className={dataOrder?.typeVAT === 'PERSONAL' ? 'btnActiveVAT' : 'btnVAT'}>
                          Cá nhân
                        </Button>
                      </div>
                    </Col>
                    <Col xs={24} xl={8}>
                      <Form.Item name="name" label={dataOrder?.typeVAT === 'PERSONAL' ? "Họ và tên" : 'Tên công ty'} rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }]}>
                        <Input
                          allowClear
                          prefix={<img src={dataOrder?.typeVAT === 'PERSONAL' ? Images.ICUser2 : Images.ICCongTy} style={{ marginRight: 3 }} />}
                          placeholder={dataOrder?.typeVAT === 'PERSONAL' ? "Nhập họ và tên" : 'Nhập tên công ty'}
                          onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "vat_name" })}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} xl={8}>
                      <Form.Item name="taxCode" label="Mã số thuế" rules={[
                        {
                          required: true, message: 'Vui lòng nhập thông tin!',
                        },
                        {
                          message: 'Mã số thuế không hợp lệ!', pattern: /^[\d\-\/.\s]{10,}$/
                        }
                      ]}>
                        <Input
                          allowClear
                          prefix={<img src={Images.ICMST} style={{ marginRight: 3 }} />}
                          placeholder="Nhập mã số thuế"
                          onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "vat_taxCode" })}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} xl={8}>
                      <Form.Item name="address" label="Địa chỉ" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }]}>
                        <Input
                          allowClear
                          prefix={<img src={Images.ICDiaChiVAT} style={{ marginRight: 3 }} />}
                          placeholder="Nhập mã số thuế"
                          onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "vat_address" })}
                        />
                      </Form.Item>
                    </Col>
                  </>
                }
              </Row>
            </div>
          </Col>

          <Col xl={24} xs={0}><div style={{ height: 1, width: '100%', background: '#D2D2D2' }}></div></Col>

          <Col xs={24}>
            <div className="card-info" style={isMobile ? {} : { padding: 0, background: '#fff0' }}>
              <Row gutter={[4, 4]}>
                {
                  (Helper.getParamUrlByKey('platform') === 'app' && dataFees?.subsidyAmount > 0) &&
                  <Col xs={24} xl={12}>
                    <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 5, gap: 10 }}>
                      <Form.Item style={{ width: '100%' }} name="subsidies">
                        <div style={{ marginBottom: 4 }}>
                          <div>Khoản trợ giá</div>
                          <div style={{ position: 'relative' }}>
                            <Input
                              autoComplete="off"
                              inputMode="numeric"
                              placeholder="Nhập số tiền trợ giá"
                              value={subsidy ? _formatMoney(subsidy) : ''}
                              onChange={(e) => {
                                const raw = e.target.value.replace(/\./g, '').replace(/,/g, '');
                                const num = parseInt(raw, 10);
                                if (isNaN(num) || num <= 0) {
                                  setSubsidy(0);
                                  setIsMaxSubsidy(false);
                                  return;
                                }
                                if (num >= dataFees?.subsidyAmount) {
                                  setSubsidy(dataFees?.subsidyAmount);
                                  setIsMaxSubsidy(true);
                                } else {
                                  setSubsidy(num);
                                  setIsMaxSubsidy(false);
                                }
                              }}
                            />
                            <div style={{
                              position: 'absolute',
                              right: 8,
                              top: '50%',
                              transform: 'translateY(-50%)',
                              display: 'flex',
                              alignItems: 'center',
                              gap: 6,
                            }}>
                              <span style={{ color: '#646D69', fontSize: 14 }}>VNĐ</span>
                              {subsidy > 0 && (
                                <span
                                  onClick={() => { setSubsidy(0); setIsMaxSubsidy(false); }}
                                  style={{ cursor: 'pointer', color: '#646D69', fontSize: 14, marginRight: 2 }}
                                >
                                  {"X"}
                                </span>
                              )}
                              <div
                                onClick={() => {
                                  if (!isMaxSubsidy) {
                                    setSubsidy(dataFees?.subsidyAmount);
                                    setIsMaxSubsidy(true);
                                  }
                                }}
                                style={{
                                  cursor: isMaxSubsidy ? 'not-allowed' : 'pointer',
                                  background: isMaxSubsidy ? '#d9d9d9' : '#F0F2F5',
                                  border: isMaxSubsidy ? '1px solid #d9d9d9' : '1px solid #D2D2D2',
                                  borderRadius: 6,
                                  padding: '4px 10px',
                                  color: isMaxSubsidy ? '#999' : '#343A40',
                                  fontWeight: 500,
                                  fontSize: 12,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 3,
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <img src={IconArrowUp} alt="arrow up" style={{ width: 16, height: 16 }}/><b>Tối đa</b>
                              </div>
                            </div>
                          </div>
                          <div style={{ color: '#F58220', fontSize: 12, marginTop: 4, fontStyle: 'italic' }}>
                            Khoản trợ giá tối đa: <b>{_formatMoney(dataFees?.subsidyAmount || 0)} </b>VNĐ
                          </div>
                        </div>
                      </Form.Item>
                    </div>
                  </Col>
                }

                <Col xs={24} xl={dataFees?.subsidies ? 12 : 24}>
                  <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 5, gap: 10 }}>
                    <Form.Item style={{ width: '100%' }} name="redeemCode" label="Mã ưu đãi"
                      rules={[
                        { required: false, message: 'Vui lòng nhập thông tin!' }
                      ]}>
                      <Input
                        disabled={showReward}
                        allowClear
                        prefix={<img src={Images.ICGiamGia} width={20} />}
                        placeholder="Nhập mã ưu đãi"
                        onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "redeemCode" })}
                      />
                    </Form.Item>
                    <Button
                      disabled={showReward}
                      onClick={() => RedeemVerify()}
                      style={{ backgroundColor: '#009B4B', height: 44, width: isMobile ? 85 : 96, color: '#fff', fontWeight: 500, borderRadius: 8 }}
                    >
                      Áp dụng
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>

          <Col xl={24} xs={0}><div style={{ height: 1, width: '100%', background: '#D2D2D2' }}></div></Col>

          <Col xs={24}>
            <div className="card-info" style={isMobile ? {} : { padding: 0, background: '#fff0' }}>
              <div className="info-row">
                <div style={{ fontSize: !isMobile ? 18 : '', color: '#343A40' }}>Tổng phí bảo hiểm:</div>
                <div style={{ fontWeight: 600, fontSize: !isMobile ? 18 : '', color: '#343A40' }}>{Helper.formatMoney(dataFees?.totalInsured)} VNĐ</div>
              </div>
              <div className="info-row">
                <div style={{ fontSize: !isMobile ? 18 : '', color: '#343A40' }}>Ưu đãi:</div>
                <div style={{ fontSize: !isMobile ? 18 : '', fontWeight: 600, color: '#343A40' }}>{dataFees?.discountAmount ? Helper.formatMoney(dataFees?.discountAmount) : 0} VNĐ</div>
              </div>
              {
                showReward &&
                <div className="info-row">
                  <div style={{ fontSize: !isMobile ? 18 : '' }}>Áp dụng tiền thưởng:</div>
                  <div style={{ fontSize: !isMobile ? 18 : '', fontWeight: 600 }}>-{dataFees.reward ? Helper.formatMoney(dataFees.reward) : ''} VNĐ</div>
                </div>
              }
              {(Helper.getParamUrlByKey('platform') === 'app' && dataFees?.subsidyAmount > 0) && (
                <div className="info-row">
                  <div style={{ fontSize: !isMobile ? 18 : '', color: '#343A40' }}>Trợ giá:</div>
                  <div style={{ fontSize: !isMobile ? 18 : '', fontWeight: 600, color: '#343A40' }}>{Helper.formatMoney(subsidy)} VNĐ</div>
                </div>
              )}
              <div className="info-row">
                <div style={{ fontSize: !isMobile ? 20 : 16, fontWeight: 600, color: '#343A40' }}>Tổng tiền thanh toán:</div>
                <div style={{ fontSize: !isMobile ? 20 : 16, fontWeight: 600, color: '#FB7800' }}>
                  {Helper.formatMoney(Math.max(0, (dataFees?.totalInsured || 0) - (dataFees?.reward || 0) - (dataFees?.discountAmount || 0) - (subsidy || 0)))} VNĐ
                </div>
              </div>
            </div>
          </Col>
          <Col xl={24} xs={0}><div style={{ height: 1, width: '100%', background: '#D2D2D2' }}></div></Col>
          {
            (Helper.getParamUrlByKey('platform') === 'app' && !showReward) &&
            <>
              <Col xs={24}>
                <div style={{ background: '#F2FDF4' }} className="card-info">
                  <div className="info-row">
                    <div style={{ fontSize: !isMobile ? 20 : 16, fontWeight: 600 }}>Lương doanh thu:</div>
                    <div style={{ fontSize: !isMobile ? 20 : 16, fontWeight: 600, color: '#009B4B' }}>{dataFees?.nonCommission ? 0 : Helper.formatMoney(Math.max(0, (dataFees.commision || 0) - (subsidy || 0)))} VNĐ</div>
                  </div>
                </div>
              </Col>
              <Col xl={24} xs={0}><div style={{ height: 1, width: '100%', background: '#D2D2D2' }}></div></Col>
            </>
          }
          <Col xs={24} xl={12}>
            <Form.Item name="rule" label=""
              rules={[
                {
                  required: true,
                  validator: (_, value) =>
                    value && value.length === 2
                      ? Promise.resolve()
                      : Promise.reject(new Error('Vui lòng đồng ý tất cả điều kiện, chính sách!')),
                },
              ]}
            >
              <Checkbox.Group style={{ display: 'grid', gap: isMobile ? 8 : 10 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5 }}>
                  <Checkbox value="1" />
                  <div style={{ fontSize: isMobile ? 14 : 16 }}>
                    Tôi xác nhận thông tin kê khai là trung thực, đầy đủ; đã đọc và đồng ý với {" "}
                    <span onClick={() => openQuytac()} style={{ color: '#0044CC', cursor: 'pointer', fontSize: isMobile ? 14 : 16 }}>Quy tắc & Điều khoản sản phẩm bảo hiểm;</span>{" "}
                    đồng ý để Global Care và các đơn vị liên quan (cổng thanh toán, doanh nghiệp bảo hiểm) chia sẻ, sử dụng thông tin nhằm phát hành, quản lý hợp đồng, tư vấn và hỗ trợ dịch vụ
                  </div>
                </div>
                {/* <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5 }}>
                  <Checkbox value="2" />
                  <div style={{ fontSize: isMobile ? 14 : 16 }}>Tôi đồng ý với <span onClick={() => OpenLink("https://cdn.globalcare.vn/private/document/pdf/globalcare/2024-05-06-Chinh-sach-bao-mat-du-lieu-ca-nhan.pdf")} style={{ color: '#0044CC', cursor: 'pointer', fontSize: isMobile ? 14 : 16 }}>"Điều khoản & điều kiện chính sách thu thập, xử lý dữ liệu cá nhân"</span>.</div>
                </div> */}
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 5 }}>
                  <Checkbox value="3" />
                  <div style={{ fontSize: isMobile ? 14 : 16 }}>
                    Tôi xác nhận {" "}
                    <span
                      // onClick={() => OpenLink('https://cdn.globalcare.vn/private/document/pdf/globalcare/2024-GC-CHINH-SACH-PHONG-CHONG-GIAN-LAN-THAM-NHUNG.pdf')}
                      style={{ color: '#000', fontSize: isMobile ? 14 : 16, fontWeight: "600" }}>
                      là người được bảo hiểm hoặc đã được người được bảo hiểm ủy quyền hợp pháp
                    </span>
                    {" "}
                    thực hiện giao dịch, và chịu trách nhiệm về tính chính xác của thông tin cũng như mọi khiếu nại liên quan.
                  </div>
                </div>
              </Checkbox.Group>
            </Form.Item>
            <div style={{ color: '#BF272D', fontSize: isMobile ? 12 : 14, marginTop: 8 }}>
              Lưu ý: Khi chọn vào mục này, đồng nghĩa việc kê khai bảo hiểm đã xong và quý khách không thể cập nhật lại.
            </div>
          </Col>
          <Col xs={24} xl={12} style={{ marginTop: isMobile ? -10 : 0 }}>
            <Signature form={form} />
          </Col>
        </Row>
        <ButtonComponent btnText={'Thanh toán'} />
        <style jsx>{`
        .card-info {
          background: #fff;
          border-radius: ${isMobile ? '8px' : '16px'};
          padding: ${isMobile ? '10px' : '15px'};
          display: grid;
          gap: 10px;
        }
        .card {
          background: #EDFBF0;
          border-radius: 16px;
          padding: 10px;
          // box-shadow: 0px 0px 8px 0px #0000001a;
          display: grid;
          gap: 10px;
          // border: 0.5px solid #d2d2d2;
        }
        .info-gird {
          font-size: ${isMobile ? '12px' : '14px !important'};
          display: gird;
          align-items: center;
          justify-content: space-between;
        }
        .info-gird.gray {
          color: #646D69;
          align-items: flex-start;
        }
        .info-row.gray {
          color: #646D69;
          align-items: flex-start;
        }
        .success {
          color: #009b4b;
          font-weight: 600;
        }
        .btnVAT { 
        background-color: ${!isMobile ? '#fff' : '#F0F2F5'} !important; 
        height: 44px;
        width: ${isMobile ? '50%' : '124px'}; 
        color: #646D69 !important;
        border: 1px solid #d2d2d2; 
        boxShadow: none;
        font-weight: 500 ;
        border-radius: 8px;
        }
        .btnActiveVAT { 
        background-color: #009B4B !important; 
        height: 44px;
        width: ${isMobile ? '50%' : '124px'}; 
        color: #fff !important;
        border: none; 
        boxShadow: none;
        font-weight: 500 !important;
        border-radius: 8px;
        }

        .info-row {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 10px;
        }

        .highlight {
          color: #fb7800;
          font-weight: 600;
        }
      `}</style>
      </Form>
    </>
  );
}

export default PaymentInfomation;